export default defineNuxtRouteMiddleware(async (to) => {
  const userStore = useUserStore();

  const guestOnlyRoutes = [
    "/login",
    "/register",
    "/forgot-password",
    "/reset-password",
    "/verify"
  ];

  const path = to.path !== "/" ? to.path.replace(/\/+$/, "") : "/";

  const isGuestOnlyRoute = guestOnlyRoutes.includes(path);
  const isInfoRoute = path.startsWith('/info');
  // The OAuth callback pages (/auth/google, /auth/microsoft, /auth/linkedin)
  // must be reachable while still logged out so they can exchange the one-time
  // code for a token and sign the user in.
  const isAuthCallbackRoute = path.startsWith('/auth/');

  if (isAuthCallbackRoute) {
    return;
  }

  if (userStore.isLoggedIn) {
    if (isGuestOnlyRoute) {
      return navigateTo("/");
    }
    return;
  }

  const token = useCookie("auth_token");
  if (token.value) {
    const isValid = await userStore.validateUser();
    if (isValid) {
      if (isGuestOnlyRoute) {
        return navigateTo("/");
      }
      return;
    }
  }

  if (isGuestOnlyRoute || isInfoRoute) {
    return;
  }

  return navigateTo("/login");
});